import React, { useState } from "react";
import cssdefs from "./Header.module.css";

const Header = () => {
    
    const subLines = [
        'Maybe you had to be there.',
        'There are a million amusing things in the city. This is maybe like three of them.',
        'Amusing a small handful of people since 2002.',
        'I\'ve paid for this domain every year since 2002 and all I have is this [tshirt.jpg]'
    ]
    const randomLineNum = () => Math.floor(Math.random()*subLines.length);
    const [subLineNum, setSubLine] = useState(randomLineNum());
    
  const subClickHandler = () => {
    setSubLine((prevNum) => {
        let newNum = prevNum;
        while (newNum === prevNum) {
            newNum = randomLineNum();
        }
        return newNum;
    })
  }

  return (
    <div className={cssdefs.header}>
      <h1>amusing.org</h1>
      <h2 onClick={subClickHandler} >{subLines[subLineNum]}</h2>
    </div> 
  );
};

export default Header;
